<template>
  <div class="vg_wrapper">
    <el-tabs
        v-model="activeName"
        type="border-card"
    >
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 @isShow="isShow" ref="childTab1"/>
      </el-tab-pane>
      <el-tab-pane label="审批流转" name="second" :key="'second'" :lazy="true">
        <childTab2 :isShow="isSho" @draftState="draftState"/>
      </el-tab-pane>
      <el-tab-pane label="相关文档" name="third" :key="'third'" :lazy="true">
        <childTab3/>
      </el-tab-pane>
      <el-tab-pane label="金检日志" name="fourth" :key="'fourth'" :lazy="true">
        <childTab4/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PodtEditMain from "@/views/ProduceManagement/PodtManage/TabChild/PodtEditMain";
import PodtEditAppr from "@/views/ProduceManagement/PodtManage/TabChild/PodtEditAppr";
import PodtEditAbout from "@/views/ProduceManagement/PodtManage/TabChild/PodtEditAbout";
import PodtEditGold from "@/views/ProduceManagement/PodtManage/TabChild/PodtEditGold";
export default {
  name: 'AcctEdit',
  components: {
    childTab1: PodtEditMain,
    childTab2: PodtEditAppr,
    childTab3: PodtEditAbout,
    childTab4: PodtEditGold
  },
  data() {
    return {
      activeName: "first",
      isSho:true,
    }
  },
  created() {},
  methods: {
    isShow(val){
      this.isSho = val;
    },
    draftState(){
      this.$refs.childTab1.initData()
    },
  }
};
</script>

<style scoped lang="scss">

</style>